import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "picture",
    object: "picture",
    header: [
      /*{text: "ID", value: "id"},*/
      {text: "File", value: "file"},
      {text: "Type", value: "type"},
      {text: "Actions", value: "actions", sortable: false}
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
